import React, { ReactNode } from 'react';
import '../css/components/CompactActionBar.css';

interface CompactActionBarProps {
  leftActions?: ReactNode;
  rightActions?: ReactNode;
  children?: ReactNode;
}

const CompactActionBar: React.FC<CompactActionBarProps> = ({ 
  leftActions, 
  rightActions,
  children 
}) => {
  return (
    <div className="compact-action-bar">
      <div className="action-bar-left">
        {leftActions}
        {children}
      </div>
      <div className="action-bar-right">
        {rightActions}
      </div>
    </div>
  );
};

export default CompactActionBar;
